import React from "react";
import classNames from "classnames";

class EButton extends React.Component {
  render() {
    const { className, ...rest } = this.props;

    return (
      <button className={classNames('e-button', className)} {...rest}>
        {this.props.children}
      </button>
    );
  }
}

export default EButton;


// WEBPACK FOOTER //
// ./app/components/EsportsGame/EButton/EButton.jsx